

let addInfo = document.getElementById("additional-information");
function handleRadioClick() {
    if(document.getElementById('q1973_q7_0').checked) {
        addInfo.style.display = "flex";
    }else {
        addInfo.style.display = "none";
    }
}

radioButtons = document.querySelectorAll('input[name="q1973:q7"]')
radioButtons.forEach(radio => {
    radio.addEventListener('click', handleRadioClick);
})

// let addInfo = document.getElementById("additional-information");

// radioButtons = document.querySelectorAll('.toggle')
// // console.log(radioButtons)
// radioButtons.forEach(radio => {
//   console.log(radio.dataset.value)
//   radio.addEventListener('click', function () {
//     // console.log(radio.dataset.value)
    
//     if(radio.dataset.value === "0"){
//       addInfo.style.display = "flex";
//     }else{
//       addInfo.style.display = "none";
//     }
//   });
// })